<template>
  <div class="gameplay-total">
    <p class="text3">Total</p>
    <p class="points-total">{{ points }}</p>
  </div>
</template>

<script>
export default {
  props: {
    points: Number
  }
};
</script>

<style lang="scss" scoped>
.gameplay-total {
  user-select: none;
  flex: 1;
}
.points-total {
  font-size: rems(62px);
  line-height: rems(62px);
}
</style>
